export default __webpack_public_path__ + "static/muli-v20-latin-regular-06a2b2bcce29fa0240edbc0abe0ec435.woff2";